import { CarouselType } from "@/entities/Carousel";
import {
  UploadLargeVideoOpts,
  UploadLargeVideoParams,
} from "@/types/Api/File.ts";
import { GetCreditInfo } from "@/types/Api/User/Info/getCreditInfo";
import { UserInfo } from "@/types/Api/User/MyAccount/userInfo";
import { GetNoticeList } from "@/types/Api/User/Notice/getNoticeList";
import { PaymentType } from "@/types/Api/User/PaymentType";
import { GetBankInfo } from "@/types/Api/User/PaymentType/getBankInfo";
import { APIUserMyAccountLogin } from "@/types/Api/User/User/MyAccount/login";
import { APIUserMyAccountRegister } from "@/types/Api/User/User/MyAccount/register";
import { AddRealNameAuthParams } from "@/types/Api/User/cervify";
import { UserChangeTypeMap } from "@/types/Api/User/change";
import { request } from "@/utils/request";

// 用户账号密码登录
export const login = (data: {
  userName: string;
  password: string;
  code: string;
  verifyUniqid: string;
  verifyToken: string;
}) =>
  request<APIUserMyAccountLogin>({
    url: "/Api/User/MyAccount/login",
    method: "POST",
    data,
  });

// 用户手机号短信登录
export const loginSMS = (data: {
  phoneNumber: string;
  smsCode: string;
  verifyToken: string;
  code: string;
  verifyUniqid: string;
}) =>
  request<APIUserMyAccountLogin>({
    url: "/Api/User/MyAccount/loginSms",
    method: "POST",
    data,
  });

// 用户注册
export const register = (data: {
  userName: string; // 手机号
  password: string;
  code: string;
  verifyUniqid: string;
  smsCode: string;
  verifyToken: string;
}) =>
  request<APIUserMyAccountRegister>({
    url: "/Api/User/MyAccount/register",
    method: "POST",
    data,
  });

// 获取公告
export const getNoticeList = (data: any) =>
  request<GetNoticeList["response"]>({
    url: "/Api/User/Notice/getNoticeList",
    method: "GET",
    data,
  });

export const getAnnouncement = (data: any) =>
  request<any>({
    url: "/Api/User/Message/Announcement/index",
    method: "GET",
    data,
  });

// 支付扫码订单
export const payUserDeposit = (data: any) =>
  request<any>({
    url: "/Api/User/TransferOrder/userDeposit",
    method: "POST",
    data,
  });

export const loginDevice = (data: {
  userName?: string;
  password?: string;
  phoneNumber?: string,
  smsCode?: string,
  code: string;
  verifyUniqid: string;
  verifyToken: string;
  securePassword: string;
}) =>
  request<APIUserMyAccountLogin>({
    url: "/Api/User/MyAccount/loginDevice",
    method: "POST",
    data,
  });

  //用户设备校验
export const checkDevice = (data: {
  userName?: string;
  password?: string;
  phoneNumber?: string,
  smsCode?: string,
  code: string;
  verifyUniqid: string;
  verifyToken: string;
  securePassword: string;
}) =>
  request<APIUserMyAccountLogin>({
    url: "/Api/User/info/checkDevice",
    method: "POST",
    data,
  });


//f
export const upload = (data: any) =>
  request<any>({
    method: "POST",
    url: "/Api/User/UploadFile/uploadImg",
    data,
  });

export const QRCodeLoginScan = (data: { uuid: string }) =>
  request<any>({
    url: "/Api/User/MyAccount/QRCodeLoginScan",
    method: "GET",
    data,
  });

export const QRCodeLoginConfirm = (data: { uuid: string }) =>
  request<{
    deviceModel: string;
    operatingSystem: string;
    scannedUserNickname: string;
  }>({
    url: "/Api/User/MyAccount/QRCodeLoginConfirm",
    method: "POST",
    data,
  });

export const QRCodeLoginCancel = (data: { uuid: string }) =>
  request<any>({
    url: "/Api/User/MyAccount/QRCodeLoginCancel",
    method: "POST",
    data,
  });

export const checkQRCodeLoginUuid = (data: { uuid: string }) =>
  request<{
    state: "scanned" | "confirm" | "canceled" | "invalid";
    userInfo: UserInfo["response"];
    token: string;
  }>({
    url: "/Api/Common/QRLogin/checkQRCodeLoginUuid",
    method: "GET",
    data,
  });

export const getUserInfo = (data: any) =>
  request<UserInfo["response"]>({
    url: "/Api/User/MyAccount/userInfo",
    method: "GET",
    data,
  });

/**
 * 重置登录密码
 * @param data
 */
export const resetPwd = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/resetPwd",
    method: "POST",
    data,
  });

// 初始化绑定
export const setPwd = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/setPwd",
    method: "POST",
    data,
  });

// 绑定手机号
export const checkBindPhoneNumber = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/checkBindPhoneNumber",
    method: "POST",
    data,
  });

export const resetSecPwd = (data: any) =>
  request<any>({
    url: "/Api/User/Account/resetSecPwd",
    method: "POST",
    data,
  });

export const setSecPwd = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/setSecPwd",
    method: "POST",
    data,
  });

// 实名认证
export const addRealNameAuth = (data: AddRealNameAuthParams) =>
  request<string | boolean>({
    url: "/Api/User/RealNameAuth/add",
    method: "POST",
    data,
  });

// 个人帐变
export const Change = (data: any) =>
  request<any>({
    url: "/Api/User/Change",
    method: "POST",
    data,
  });

// 获取用户账变类型
export const getChangeType = () =>
  request<UserChangeTypeMap>({
    url: "/Api/User/Change/getChangeType",
    method: "GET",
  });

// 获取用户信用等级信息
export const getCreditInfo = (data: GetCreditInfo["request"]) =>
  request<GetCreditInfo["response"]>({
    url: "/Api/User/Info/getCreditInfo",
    method: "GET",
    data,
  });

// 获取收款信息
export const getPaymentType = (data: PaymentType["request"]) =>
  request<PaymentType["response"]>({
    url: "/Api/User/PaymentType",
    method: "GET",
    data,
  });

// 设置用户头像
export const setAvatar = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/setAvatar",
    method: "POST",
    data,
  });

// 获取站内信
export const getMessages = (data: any) =>
  request<any>({
    url: "/Api/User/Message/Message/index",
    method: "GET",
    data,
  });

// 站内信设置已读
export const setRead = (data: any) =>
  request<any>({
    url: "/Api/User/Message/Message/setRead",
    method: "POST",
    data,
  });

// 获取消息未读
export const getUnreadCount = (data: any) =>
  request<any>({
    url: "/Api/User/Message/Message/getUnreadCount",
    method: "GET",
    data,
  });

// 一键已读
export const oneClickRead = (data: any) =>
  request<any>({
    url: "/Api/User/Message/Message/oneClickRead",
    method: "GET",
    data,
  });

// 一键删除
export const deleteMessages = (data: any) =>
  request<any>({
    url: "/Api/User/Message/Message/delete",
    method: "POST",
    data,
  });

// 设备列表
export const myDeviceList = (data: any) =>
  request<any>({
    url: "/Api/User/Device/myDeviceList",
    method: "GET",
    data,
  });

// 删除设备
export const deleteDevice = (data: any) =>
  request<any>({
    url: "/Api/User/Device/deleteDevice",
    method: "POST",
    data,
  });

// 短信登录
export const smsSignIn = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/loginSms",
    method: "POST",
    data,
  });

//解绑银行卡
export const unBind = (data: { securePassword: string; id: number | string }) =>
  request<any>({
    url: "/Api/User/PaymentType/unBind",
    method: "POST",
    data,
  });

// 获取google验证的数据
export const bindGoogleAuthenticator = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/bindGoogleAuthenticator",
    method: "POST",
    data,
  });

// 验证google验证码绑定
export const checkBindGoogleAuthenticator = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/checkBindGoogleAuthenticator",
    method: "POST",
    data,
  });

// 解绑google 验证
export const unBindGoogleAuthenticator = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/unBindGoogleAuthenticator",
    method: "POST",
    data,
  });

export const checkGoogleAuthenticator = (data: { safeCode: string }) =>
  request<any>({
    url: "/Api/User/MyAccount/checkGoogleAuthenticator",
    method: "POST",
    data,
  });

export const addUserTransfer = (data: any) =>
  request<any>({
    url: "/Api/User/Account/addUserTransfer",
    method: "POST",
    data,
  });

export const myChangeDetail = (data: any) =>
  request<any>({
    url: "/Api/User/Change/myChangeDetail",
    method: "POST",
    data,
  });

export const uploadBase64Img = (data: any) =>
  request<any>({
    url: "/Api/User/UploadFile/uploadBase64Img",
    method: "POST",
    data,
  });

export const uploadVideo = (data: any) =>
  request<any>({
    url: "/Api/User/UploadFile/uploadVideo",
    method: "POST",
    data,
  });

export const uploadLargeVideo = (
  data: UploadLargeVideoParams,
  opts: UploadLargeVideoOpts = {}
) =>
  request<any>({
    url: "/Api/User/UploadFile/uploadLargeVideo",
    method: "POST",
    data,
    // opts
  });

export const uploadFileToken = (data: any) =>
  request<any>({
    url: "/Api/User/UploadFile/uploadFileToken",
    method: "POST",
    data,
  });

export const editNickName = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/editNickname",
    method: "POST",
    data,
  });

// 绑定用户名
export const editUserName = (data: any) =>
  request<any>({
    url: "/Api/User/MyAccount/editUserName",
    method: "POST",
    data,
  });

export const addPayment = (data: any) =>
  request<any>({
    url: "/Api/User/PaymentType/add",
    method: "POST",
    data,
  });

export const getBankInfo = (data: GetBankInfo["request"]) =>
  request<GetBankInfo["response"]>({
    url: "/Api/User/PaymentType/getBankInfo",
    method: "GET",
    data,
  });
  

  
export const getCarouselChartInfo = () =>
  request<any>({
    url: "/Api/User/Info/getCarouselChartInfo",
    method: "GET",
  });

  export const getCarouselChartDetailInfo = (data:{id: number}) =>
  request<any>({
    url: "/Api/User/Info/getCarouselChartDetail",
    method: "GET",
    data
  });

  // 查看复制地址校验
  export const checkAddress = (data:{securePassword: string,code:string,verifyUniqid:string}) =>
    request<any>({
      url: "/Api/User/Info/checkPassword",
      method: "POST",
      data
    });